import { render, staticRenderFns } from "./BlockEdit.vue?vue&type=template&id=5a8e7760&scoped=true&"
import script from "./BlockEdit.vue?vue&type=script&lang=js&"
export * from "./BlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e7760",
  null
  
)

export default component.exports